import React, {useEffect} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";
import {Sidebar} from "primereact/sidebar";
import {BreadCrumb} from "primereact/breadcrumb";
import {Dialog} from "primereact/dialog";
import CrmActionbuttonsComponent from "../../components/2.1/crm/CrmActionbuttonsComponent";
import TaskFormComponent from "../../components/2.1/crm/task/TaskFormComponent";
import LeadListComponent from "../../components/2.1/crm/lead/LeadListComponent";
import LeadFormComponent from "../../components/2.1/crm/lead/LeadFormComponent";
import ActionListComponent from "../../components/2.1/crm/action/ActionListComponent";
import ActionFormComponent from "../../components/2.1/crm/action/ActionFormComponent";
import CampaignListComponent from "../../components/2.1/crm/campaign/CampaignListComponent";
import CampaignFormComponent from "../../components/2.1/crm/campaign/CampaignFormComponent";
import NewsletterConnectionSettingsComponent from "../../components/2.1/crm/campaign/NewsletterConnectionSettingsComponent";
import StepListComponent from "../../components/2.1/crm/step/StepListComponent";
import CampaigShowComponent from "../../components/2.1/crm/campaign/CampaignShowComponent";
import DealFormComponent from "../../components/2.1/crm/deal/DealFormComponent";
import OpportunityKanbanComponent from "../../components/2.1/crm/deal/OpportunityKanbanComponent";
import CategoryListComponent from "../../components/2.1/crm/category/CategoryListComponent";
import CategoryFormComponent from "../../components/2.1/crm/category/CategoryFormComponent";
import SubjectListComponent from "../../components/2.1/crm/subject/SubjectListComponent";
import SubjectFormComponent from "../../components/2.1/crm/subject/SubjectFormComponent";
import ImportListComponent from "../../components/2.1/import/ImportListComponent";
import ImportFormComponent from "../../components/2.1/import/ImportFormComponent";
import StepFormComponent from "../../components/2.1/crm/step/StepFormComponent";
import PartnerListComponent from "../../components/2.1/partner/PartnerListComponent";
import PartnerFormComponent from "../../components/2.0/partner/PartnerFormComponent";
import PartnerShowComponent from "../../components/2.0/partner/PartnerShowComponent";
import CrmDashboardComponent from '../../components/2.1/crm/CrmDashboardComponent';
import TaskKanbanComponent from '../../components/2.1/crm/task/TaskKanbanComponent';
import PipelineSettingsComponent from '../../components/2.1/crm/pipeline/PipelineSettingsComponent';
import TaskStatusSettingsComponent from '../../components/2.1/crm/task/TaskStatusSettingsComponent';
import SegmentSettingsComponent from '../../components/2.1/crm/audience/SegmentSettingsComponent';
import AudienceSettingsComponent from '../../components/2.1/crm/audience/AudienceSettingsComponent';

export const CrmPage = (props) => {
  const {t} = props;

  const history = useHistory();
  const {entity, action, id} = useParams();
  const normalizedRoles = (localStorage.getItem('roles') || '[]').toUpperCase();
  const canReadLeads = normalizedRoles.includes('ROLE_CRM_LEAD_READ') || normalizedRoles.includes('ROLE_CRM_LEAD_ROLE');
  const canReadDashboard = normalizedRoles.includes('ROLE_CRM_DASHBOARD');

  useEffect(() => {
    if (entity === 'campaign' && action === 'read' && id) {
      history.replace('/crm/campaign/update/' + id);
      return;
    }
    document.title = 'CRM' + ' - ' + process.env.REACT_APP_TITLE;
    setTimeout(function () {
      if (document.getElementsByClassName('activeMenu')[0]) {
        document.getElementsByClassName('activeMenu')[0].classList.remove("activeMenu")
      }
      if (document.getElementsByClassName('crm')[0]) {
        document.getElementsByClassName('crm')[0].classList.add("activeMenu")
      }
    }, 1000)
  }, [entity, action, id, history]);

  return (
    <div className={"CrmPage"}>
      {localStorage.getItem('module_crm') ? (
        <>
          {entity === 'dashboard' && canReadDashboard &&
            <div className={"PageContent p-p-5 p-mx-auto"}>
              <CrmDashboardComponent />
            </div>
          }
          {!entity && canReadDashboard &&
            <div className={"PageContent p-p-5 p-mx-auto"}>
              <CrmDashboardComponent dashboardId={localStorage.getItem('module_crm_dashboard')} />
            </div>
          }
          {entity === 'task' && (localStorage.getItem('roles') || '[]').includes('role_crm_task_read') &&
            <div className={"PageContent p-p-5 p-mx-auto"}>
              <TaskKanbanComponent />
            </div>
          }
          {entity === 'task' && (action === 'create' || action === 'update') &&
            <Sidebar position="left"
                     showCloseIcon={false}
                     visible={action === 'create' || action === 'update'}
                     closeOnEscape={true}
                     style={{width: '780px'}}
                     onHide={() => {
                       history.push('/crm/task')
                     }}>
              <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {id ? t('taskUpdate') : t('taskCreate')}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>
                    <CrmActionbuttonsComponent/>
                  </span>
                    <a onClick={() => {
                      history.push('/crm/task')
                    }}
                       className={"p-button  p-button-secondary p-ml-2"}>
                      <i className={"pi pi-arrow-left"}></i>
                      &nbsp;
                      {t('back')}
                    </a>
                  </div>
                </div>
                <Panel>
                  <TaskFormComponent backlink={'/crm/task'}/>
                </Panel>
              </div>
            </Sidebar>
          }
          {entity === 'lead' && canReadLeads &&
            <div className={"PageContent p-p-5 p-mx-auto"}>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                  <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                    {t('leadList')}
                  </h2>
                </div>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>
                    <CrmActionbuttonsComponent/>
                  </span>
                  {(localStorage.getItem('roles') || '[]').includes('role_crm_lead_write') && (
                    <a onClick={() => {
                      history.push('/crm/lead/create')
                    }}
                       className={"p-button  p-button-success p-ml-2"}>
                      <i className={"pi pi-plus"}></i>
                      &nbsp;
                      {t('addLead')}
                    </a>
                  )}
                </div>
              </div>
              <Panel>
                <LeadListComponent backlink={'/crm/lead'}/>
              </Panel>
            </div>
          }
          {entity === 'lead' && (action === 'create' || action === 'update') && (localStorage.getItem('roles') || '[]').includes('role_crm_lead_write') &&
            <Sidebar position="left"
                     showCloseIcon={false}
                     visible={action === 'create' || action === 'update'}
                     closeOnEscape={true}
                     style={{width: '780px'}}
                     onHide={() => {
                       history.push('/crm/lead')
                     }}>
              <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {id ? t('leadUpdate') : t('leadCreate')}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>
                    <CrmActionbuttonsComponent/>
                  </span>
                    <a onClick={() => {
                      history.push('/crm/lead')
                    }}
                       className={"p-button  p-button-secondary p-ml-2"}>
                      <i className={"pi pi-arrow-left"}></i>
                      &nbsp;
                      {t('back')}
                    </a>
                  </div>
                </div>
                <Panel>
                  <LeadFormComponent backlink={'/crm/lead'}/>
                </Panel>
                {id && id !== 'undefined' &&
                  <>
                    <div className={"p-grid p-mt-3"}>
                      <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                        <h3 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                          {t('activityList')}
                        </h3>
                      </div>
                      <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                        {(localStorage.getItem('roles') || '[]').includes('role_crm_action_write') && (
                          <a onClick={() => {
                            history.push('/crm/lead/update/' + id + '?create=action&leadId=' + id)
                          }}
                             className={"p-button  p-button-success p-button-sm p-ml-2"}>
                            <i className={"pi pi-plus"}></i>
                            &nbsp;
                            {t('addActivity')}
                          </a>
                        )}
                      </div>
                    </div>
                    <Panel>
                      <ActionListComponent leadId={id}/>
                    </Panel>
                    <Dialog visible={window.App.urlVars().create === 'action' || window.App.urlVars().update === 'action'}
                            style={{width: '750px'}}
                            header={() => {if(window.App.urlVars().create){return t('addActivityToLead')}else {return t('activityUpdate')}}}
                            modal
                            onHide={() => {
                              history.push('/crm/lead/update/' + id)
                            }}>
                      <ActionFormComponent backlink={'/crm/lead/update/' + id}/>
                    </Dialog>
                  </>
                }
              </div>
            </Sidebar>
          }
          {entity === 'action' && localStorage.getItem('roles')?.toString().includes('role_crm_action_read') &&
            <div className={"PageContent p-p-5 p-mx-auto"}>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                  <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                    {t('activityList')}
                  </h2>
                </div>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>
                    <CrmActionbuttonsComponent/>
                  </span>
                  {(localStorage.getItem('roles') || '[]').includes('role_crm_action_write') && (
                    <a onClick={() => {
                      history.push('/crm/action/create')
                    }}
                      className={"p-button  p-button-success p-ml-2"}>
                      <i className={"pi pi-plus"}></i>
                      &nbsp;
                      {t('addActivity')}
                    </a>
                  )}
                </div>
              </div>
              <Panel>
                <ActionListComponent backlink={'/crm/action'}/>
              </Panel>
            </div>
          }
          {entity === 'action' && (action === 'create' || action === 'update') &&  localStorage.getItem('roles')?.toString().includes('role_crm_action_write')  &&
            <Sidebar position="left"
                     showCloseIcon={false}
                     visible={action === 'create' || action === 'update'}
                     closeOnEscape={true}
                     style={{width: '780px'}}
                     onHide={() => {
                       history.push('/crm/action')
                     }}>
              <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {id ? t('activityUpdate') : t('activityCreate')}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>
                    <CrmActionbuttonsComponent/>
                  </span>
                    <a onClick={() => {
                      history.push('/crm/action')
                    }}
                       className={"p-button  p-button-secondary p-ml-2"}>
                      <i className={"pi pi-arrow-left"}></i>
                      &nbsp;
                      {t('back')}
                    </a>
                  </div>
                </div>
                <Panel>
                  <ActionFormComponent backlink={'/crm/action'}/>
                </Panel>
              </div>
            </Sidebar>
          }
          {entity === 'campaign' && (!action || action === 'update' || action === 'create') && (localStorage.getItem('roles') || '[]').includes('role_crm_campaign_read') &&
            <div className={"PageContent p-p-5 p-mx-auto"}>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                  <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                    {t('newsletterCampaigns')}
                  </h2>
                </div>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>
                    <CrmActionbuttonsComponent/>
                  </span>
                  {localStorage.getItem('roles')?.toString().includes('role_crm_campaign_write') && (
                    <a onClick={() => {
                      history.push('/crm/campaign/create')
                    }}
                       className={"p-button  p-button-success p-ml-2"}>
                      <i className={"pi pi-plus"}></i>
                      &nbsp;
                      {t('newsletterNewCampaign')}
                    </a>
                  )}
                </div>
              </div>
              <Panel>
                <CampaignListComponent backlink={'/crm/capaign'}/>
              </Panel>
            </div>
          }
          {entity === 'campaign' && (action === 'create' || action === 'update') && (localStorage.getItem('roles') || '[]').includes('role_crm_campaign_write') &&
            <Sidebar position="left"
                     showCloseIcon={false}
                     visible={action === 'create' || action === 'update'}
                     closeOnEscape={true}
                     style={{width: 'min(1180px, 96vw)'}}
                     onHide={() => {
                       history.push('/crm/campaign')
                     }}>
              <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {id ? t('newsletterEditCampaign') : t('newsletterNewCampaign')}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>
                    <CrmActionbuttonsComponent/>
                  </span>
                    <a onClick={() => {
                      history.push('/crm/campaign')
                    }}
                       className={"p-button  p-button-secondary p-ml-2"}>
                      <i className={"pi pi-arrow-left"}></i>
                      &nbsp;
                      {t('back')}
                    </a>
                  </div>
                </div>
                <Panel>
                  <CampaignFormComponent backlink={'/crm/campaign'}/>
                </Panel>
                {id && false &&
                  <>
                    <div className={"p-grid p-mt-3"}>
                      <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                        <h3 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                          {t('campaignSteps')}
                        </h3>
                      </div>
                      <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                        <a onClick={() => {
                          history.push('/crm/campaign/update/' + id + '?create=step&campaignId=' + id)
                        }}
                           className={"p-button  p-button-success p-button-sm p-ml-2"}>
                          <i className={"pi pi-plus"}></i>
                          &nbsp;
                          {t('addCampaignStep')}
                        </a>
                      </div>
                    </div>
                    <Panel>
                      <StepListComponent campaignId={id}/>
                    </Panel>
                    <Dialog visible={window.App.urlVars().create === 'step' || window.App.urlVars().update === 'step'}
                            style={{width: '750px'}}
                            header={t('addCampaignStep')}
                            modal
                            onHide={() => {
                              history.push('/crm/campaign/update/' + id)
                            }}>
                      <StepFormComponent backlink={'/crm/campaign/update/' + id}/>
                    </Dialog>
                  </>
                }
              </div>
            </Sidebar>
          }
          {entity === 'campaign' && action === 'legacy-read' &&
            <div className={"PageContent p-p-5 p-mx-auto"}>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                  {localStorage.getItem('breadcrumb') ? (
                    <BreadCrumb model={JSON.parse(localStorage.getItem('breadcrumb'))}
                                home={{icon: 'pi pi-home', url: '/'}}/>
                  ) : (
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {t('campaignView')}
                    </h2>
                  )}
                </div>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>
                    <CrmActionbuttonsComponent/>
                  </span>
                  <a onClick={() => {
                    history.push('/crm/campaign')
                  }}
                     className={"p-button  p-button-secondary p-ml-2"}>
                    <i className={"pi pi-arrow-left"}></i>
                    &nbsp;
                    {t('back')}
                  </a>
                </div>
              </div>
              <Panel>
                <CampaigShowComponent backlink={'/crm/campaign'}/>
              </Panel>
              {id && (localStorage.getItem('roles') || '[]').includes('role_crm_campaign_write') &&
                <>
                  <Sidebar position="left"
                           visible={window.App.urlVars().create === 'action' || window.App.urlVars().update === 'action'}
                           closeOnEscape={true}
                           showCloseIcon={false}
                           style={{width: '780px'}}
                           onHide={() => {
                             history.push('/crm/campaign/read/' + id)
                           }}>
                    <div className={"p-grid p-mt-3"}>
                      <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                        <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                          {t('addActivityToCampaign')}
                        </h2>
                      </div>
                      <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                        <a onClick={() => {
                          history.push('/crm/campaign/read/' + id)
                        }}
                           className={"p-button  p-button-secondary p-ml-2"}>
                          <i className={"pi pi-arrow-left"}></i>
                          &nbsp;
                          {t('back')}
                        </a>
                      </div>
                    </div>
                    <Panel>
                      <ActionFormComponent backlink={'/crm/campaign/read/' + id}/>
                    </Panel>
                  </Sidebar>
                  <Sidebar position="left"
                           visible={window.App.urlVars().create === 'lead' || window.App.urlVars().update === 'lead'}
                           closeOnEscape={true}
                           showCloseIcon={false}
                           style={{width: '780px'}}
                           onHide={() => {
                             history.push('/crm/campaign/read/' + id)
                           }}>
                    <div className={"p-grid p-mt-3"}>
                      <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                        <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                          {t('addLeadToCampaign')}
                        </h2>
                      </div>
                      <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                        <a onClick={() => {
                          history.push('/crm/campaign/read/' + id)
                        }}
                           className={"p-button  p-button-secondary p-ml-2"}>
                          <i className={"pi pi-arrow-left"}></i>
                          &nbsp;
                          {t('back')}
                        </a>
                      </div>
                    </div>
                    <Panel>
                      <LeadFormComponent backlink={'/crm/campaign/read/' + id}/>
                    </Panel>
                  </Sidebar>
                </>
              }
            </div>
          }
          {entity === 'newsletter-connection' && (localStorage.getItem('roles') || '[]').includes('role_crm_campaign_read') &&
            <div className={"PageContent p-p-5 p-mx-auto"}>
              <NewsletterConnectionSettingsComponent/>
            </div>
          }
          {entity === 'segment' && (localStorage.getItem('roles') || '[]').includes('role_crm_campaign_read') &&
            <div className={"PageContent p-p-5 p-mx-auto"}><SegmentSettingsComponent/></div>
          }
          {entity === 'audience-settings' && (localStorage.getItem('roles') || '[]').includes('role_crm_campaign_read') &&
            <div className={"PageContent p-p-5 p-mx-auto"}><AudienceSettingsComponent/></div>
          }
          {entity === 'deal' && (localStorage.getItem('roles') || '[]').includes('role_crm_deal_read') &&
            <div className={"PageContent p-p-5 p-mx-auto"}>
              <OpportunityKanbanComponent />
            </div>
          }
          {entity === 'pipeline' && (localStorage.getItem('roles') || '[]').includes('role_crm_deal_read') &&
            <div className={"PageContent p-p-5 p-mx-auto"}>
              <PipelineSettingsComponent/>
            </div>
          }
          {entity === 'task-status' && (localStorage.getItem('roles') || '[]').includes('role_crm_task_read') &&
            <div className={"PageContent p-p-5 p-mx-auto"}>
              <TaskStatusSettingsComponent/>
            </div>
          }
          {entity === 'deal' && (action === 'create' || action === 'update') &&
            <Sidebar position="left"
                     showCloseIcon={false}
                     visible={action === 'create' || action === 'update'}
                     closeOnEscape={true}
                     style={{width: '780px'}}
                     onHide={() => {
                       history.push('/crm/deal')
                     }}>
              <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {id ? t('goalUpdate') : t('goalCreate')}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>
                    <CrmActionbuttonsComponent/>
                  </span>
                    <a onClick={() => {
                      history.push('/crm/deal')
                    }}
                       className={"p-button  p-button-secondary p-ml-2"}>
                      <i className={"pi pi-arrow-left"}></i>
                      &nbsp;
                      {t('back')}
                    </a>
                  </div>
                </div>
                <Panel>
                  <DealFormComponent backlink={'/crm/deal'}/>
                </Panel>
              </div>
            </Sidebar>
          }
          {entity === 'category' && (!action || action === 'create' || action === 'update') && (localStorage.getItem('roles') || '[]').includes('role_crm_category_read') &&
            <div className={"PageContent p-p-5 p-mx-auto"}>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                  <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                    {t('categoryList')}
                  </h2>
                </div>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>
                    <CrmActionbuttonsComponent/>
                  </span>
                  {(localStorage.getItem('roles') || '[]').includes('role_crm_category_write') && (
                    <a onClick={() => {
                      history.push('/crm/category/create')
                    }}
                       className={"p-button  p-button-success p-ml-2"}>
                      <i className={"pi pi-plus"}></i>
                      &nbsp;
                      {t('addCategory')}
                    </a>
                  )}
                </div>
              </div>
              <Panel>
                <CategoryListComponent backlink={'/crm/category'}/>
              </Panel>
            </div>
          }
          {entity === 'category' && (action === 'create' || action === 'update') &&
            <Sidebar position="left"
                     showCloseIcon={false}
                     visible={action === 'create' || action === 'update'}
                     closeOnEscape={true}
                     style={{width: '780px'}}
                     onHide={() => {
                       history.push('/crm/category')
                     }}>
              <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {id ? t('categoryUpdate') : t('categoryCreateAction')}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>
                    <CrmActionbuttonsComponent/>
                  </span>
                    <a onClick={() => {
                      history.push('/crm/category')
                    }}
                       className={"p-button  p-button-secondary p-ml-2"}>
                      <i className={"pi pi-arrow-left"}></i>
                      &nbsp;
                      {t('back')}
                    </a>
                  </div>
                </div>
                <Panel>
                  <CategoryFormComponent backlink={'/crm/category'}/>
                </Panel>
              </div>
            </Sidebar>
          }
          {entity === 'subject' && (!action || action === 'create' || action === 'update') && (localStorage.getItem('roles') || '[]').includes('role_crm_subject_read') &&
            <div className={"PageContent p-p-5 p-mx-auto"}>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                  <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                    {t('subjectList')}
                  </h2>
                </div>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>
                    <CrmActionbuttonsComponent/>
                  </span>
                  {(localStorage.getItem('roles') || '[]').includes('role_crm_subject_write') && (
                    <a onClick={() => {
                      history.push('/crm/subject/create')
                    }}
                       className={"p-button  p-button-success p-ml-2"}>
                      <i className={"pi pi-plus"}></i>
                      &nbsp;
                      {t('addTopic')}
                    </a>
                  )}
                </div>
              </div>
              <Panel>
                <SubjectListComponent backlink={'/crm/subject'}/>
              </Panel>
            </div>
          }
          {entity === 'subject' && (action === 'create' || action === 'update') && (localStorage.getItem('roles') || '[]').includes('role_crm_subject_write') &&
            <Sidebar position="left"
                     showCloseIcon={false}
                     visible={action === 'create' || action === 'update'}
                     closeOnEscape={true}
                     style={{width: '780px'}}
                     onHide={() => {
                       history.push('/crm/subject')
                     }}>
              <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {id ? t('topicUpdate') : t('topicCreate')}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>
                    <CrmActionbuttonsComponent/>
                  </span>
                    <a onClick={() => {
                      history.push('/crm/subject')
                    }}
                       className={"p-button  p-button-secondary p-ml-2"}>
                      <i className={"pi pi-arrow-left"}></i>
                      &nbsp;
                      {t('back')}
                    </a>
                  </div>
                </div>
                <Panel>
                  <SubjectFormComponent backlink={'/crm/subject'}/>
                </Panel>
              </div>
            </Sidebar>
          }
          {entity === 'import' && (!action || action === 'update' || action === 'create')  && (localStorage.getItem('roles') || '[]').includes('role_crm_import_read') &&
            <div className={"PageContent p-p-5 p-mx-auto"}>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                  <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                    {t('importList')}
                  </h2>
                </div>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>
                    <CrmActionbuttonsComponent/>
                  </span>
                  {(localStorage.getItem('roles') || '[]').includes('role_crm_import_write') && (
                    <a onClick={() => {
                      history.push('/crm/import/create')
                    }}
                       className={"p-button  p-button-success p-ml-2"}>
                      <i className={"pi pi-plus"}></i>
                      &nbsp;
                      {t('addImport')}
                    </a>
                  )}
                </div>
              </div>
              <Panel>
                <ImportListComponent backlink={'/crm/import'} importType="partner"/>
              </Panel>
            </div>
          }
          {entity === 'import' && (action === 'create' || action === 'update') && (localStorage.getItem('roles') || '[]').includes('role_crm_import_write') &&
            <Sidebar position="left"
                     showCloseIcon={false}
                     visible={action === 'create' || action === 'update'}
                     closeOnEscape={true}
                     style={{width: '780px'}}
                     onHide={() => {
                       history.push('/crm/import')
                     }}>
              <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {id ? t('importUpdate') : t('partnerExternalImport')}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>
                    <CrmActionbuttonsComponent/>
                  </span>
                    <a onClick={() => {
                      history.push('/crm/import')
                    }}
                       className={"p-button  p-button-secondary p-ml-2"}>
                      <i className={"pi pi-arrow-left"}></i>
                      &nbsp;
                      {t('back')}
                    </a>
                  </div>
                </div>
                <Panel>
                  <ImportFormComponent backlink={'/crm/import'} importType="partner" templateUrl="/api/v2/partner/import-template" templateFilename="partner_import_template.xlsx"/>
                </Panel>
              </div>
            </Sidebar>
          }
          <Sidebar position="bottom"
                   visible={window.App.urlVars().search === 'partner'}
                   closeOnEscape={true}
                   style={{width: '100%', height: '80%'}}
                   onHide={() => {
                     history.push('/crm/' + entity + '/' + action + '/' + id)
                   }}>
            <div className={"p-grid p-mt-3"}>
              <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                <h3 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                  {t('partnerSearch')}
                </h3>
              </div>
              <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>

              </div>
            </div>
            <Panel className={"p-mt-3"}>
              <PartnerListComponent view={"search"} backlink={'/crm/' + entity + '/' + action + '/' + id}/>
            </Panel>
          </Sidebar>
          <Dialog visible={window.App.urlVars().create === 'partner'}
                  style={{width: '980px'}}
                  header={t('partnerCreate')}
                  modal
                  onHide={() => {
                    history.push('/crm/' + entity + '/' + action + '/' + id)
                  }}>
            <PartnerFormComponent backlink={'/crm/' + entity + '/' + action + '/' + id}/>
          </Dialog>
          <Dialog visible={window.App.urlVars().show === 'partner'}
                  style={{width: '980px'}}
                  header={t('partnerView')}
                  modal
                  onHide={() => {
                    history.go(-1)
                  }}>
            <PartnerShowComponent partnerId={window.App.urlVars().partnerId}/>
          </Dialog>
        </>
      ) : (
        <p className={"p-text-center p-my-5 p-py-5"}>
          <i className={"pi pi-exclamation-circle p-d-block p-mb-5"} style={{'fontSize': '5em'}}></i>
          <span className={"p-text-bold p-d-block "}>Ehhez a modulhoz sajnos nem rendelkezel hozzáféréssel.</span>
          Amennyiben további információra van szükséged írj emailt a {process.env.REACT_APP_DEVOPS_CONTACT} címre.
          {process.env.REACT_APP_SUBSCRIPTIONS === 'enabled' &&
            <span className={"p-text-bold p-d-block p-mt-5"}>
                       <a className={"p-button p-button-warning"}
                          onClick={() => {
                            window.location.replace('/#/subscriptions');
                            window.App.forceUpdate()
                          }}
                       >
                         <i className={"pi pi-building"}></i>&nbsp;Előfizetői fiók áttekintése
                       </a>
                   </span>
          }
        </p>
      )}
    </div>
  )
}
export default withTranslation('common')(CrmPage);
